<template>
  <div class="bg">
    <!-- 搜索栏 -->
    <div class="top_search_part">
      <div class="search_box">
        <div class="search_item">
          <el-input v-model="deliveryManName" :placeholder="$t('message.deliveryNameTitle')"></el-input>
        </div>
        <div class="search_item">
          <el-input v-model="senderCompany" :placeholder="$t('message.orderTableTitle4')"></el-input>
        </div>
        <div class="search_item">
          <el-date-picker v-model="orderTime" type="daterange" range-separator=" - " align="center" :start-placeholder="$t('message.orderTimeStartHolder')" :end-placeholder="$t('message.orderTimeEndHolder')" value-format="yyyy-MM-dd"></el-date-picker>
        </div>
        <div class="search_item">
          <el-input v-model="orderNum" :placeholder="$t('message.orderSearchPlaceholder')" ></el-input>
        </div>
        <div class="search_btn" @click="searchOrderNum">{{$t('message.searchBtnText')}}</div>
        <div class="search_btn" @click="exportExcel">{{$t('message.exportText')}}</div>
      </div>
    </div>
    <!-- 搜索栏 -->
    <div class="content">
      <div class="tableBox">
        <el-table id="orderList" :data="orderList" style="width: 100%" stripe size="small" header-cell-class-name="tableHeader" cell-class-name="tableBodyer" height="100%" @sort-change="sortChange">
          <el-table-column :label="$t('message.customTableTitle1')" prop="index" width="85"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle1')" prop="ORDERNUM" min-width="210"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle3')" width="100">
            <template slot-scope="scope">
              <div class="operate_btn_box">
                <el-button class="operation_a_blue" @click.native.prevent="checkLogistics(scope.row.ORDERNUM)">{{$t('message.orderTableCheckTitle')}}</el-button>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('message.orderTableTitle4')" prop="JJGS" min-width="150"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle5')" prop="JJR" width="140"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle6')" prop="JJRPHONE" width="150"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle7') + 'pc'" prop="WPSL" width="130"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle8') + 'kg'" prop="WPZL" width="130"></el-table-column>
          <el-table-column :label="$t('message.orderTableTitle9') + 'm³'" prop="WPTJ" width="130"></el-table-column>
          <el-table-column :label="$t('message.deliveryManTitle')" prop="POSTMANNAME" min-width="130"></el-table-column>
          <el-table-column :label="$t('message.deliveryTimeTitle')" prop="deliveryTime" min-width="210" sortable="custom"></el-table-column>
        </el-table>
      </div>
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="page_no"
        :page-sizes="pageSizes"
        :page-size="page_size"
        layout="total, sizes, prev, pager, next"
        :total="totalSize"
        class="tablePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
  import { getDeliveryMan, imgSrc, getDeliveryDetailOrder, exportExcel, HTTPS } from '@/api/getData.js'
  import exportTable from '@/js/exportExcel.js'
  export default {
    name: 'deliveryDetail',
    data () {
      return {
        nameList: [],
        deliveryManName: '',
        deliveryManId: null,
        senderCompany: '',
        orderTime: [],
        orderNum: '',
        page_no: 1,
        page_size: 10,
        pageSizes: [10, 20, 30, 50, 100],
        totalSize: 0,
        orderList: [],
      }
    },
    created() {
      // 查询订单列表
      // console.log(this.$route.query)
      if (!this.$route.query.deliveryManId) {
        let param = this.$store.state.JHSS_deliveryDetail_param
        if (param.PAGE) this.page_no = param.PAGE
        if (param.TYPE) this.page_size = param.TYPE
        if (param.PSYNAME) this.deliveryManName = param.PSYNAME
        if (param.JJGS) this.senderCompany = param.JJGS
        if (param.UGUDING6 && param.DGUDING6) this.orderTime = [param.UGUDING6.split(' ')[0], param.DGUDING6.split(' ')[0]]
        if (param.ORDERNUM) this.orderNum = param.ORDERNUM
        this.getOrderList(param)
      } else {
        this.deliveryManId = this.$route.query.deliveryManId
        this.orderTime = JSON.parse(this.$route.query.orderTime)
        this.searchOrderNum()
      }
    },
    methods: {
      async getDeliveryMan (query) {
        if (query !== '') {
          let param = { USHOWNAME: query }
          let res = await getDeliveryMan(param)
          this.nameList = res.data
        } else {
          this.nameList = []
        }
      },
      // 查询订单列表
      async getOrderList (param) {
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        param = param || {}
        param.PAGE = this.page_no
        param.TYPE = this.page_size
        let res = await getDeliveryDetailOrder(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data.ds)
        this.totalSize = res.data.num
        let index = (this.page_no - 1) * this.page_size
        this.orderList = res.data.dt.map(item => {
          item.index = ++index
          item.imgSrc = imgSrc(item.TXM)
          item.deliveryTime = item.GUDING6.replace(/T/g, ' ')
          return item
        })
        this.$store.commit('setDeliveryDetailParam', param)
      },
      // 搜索
      searchOrderNum () {
        this.page_no = 1
        this.searchFun()
      },
      sizeChange (val) {
        // console.log(val)
        this.page_size = val
        this.page_no = 1
        this.searchFun()
      },
      currentChange (val) {
        // console.log(val)
        this.page_no = val
        this.searchFun()
      },
      searchFun () {
        let param = {}
        // 查询客户管理
        if (this.orderNum) {
          param.ORDERNUM = this.orderNum
        }
        if (this.deliveryManId) {
          param.PSY = this.deliveryManId
        }
        if (this.deliveryManName) {
          param.PSYNAME = this.deliveryManName
        }
        if (this.senderCompany) {
          param.JJGS = this.senderCompany
        }
        if (this.orderTime && this.orderTime.length !== 0) {
          param.UGUDING6 = this.orderTime[0] + ' 00:00:00'
          param.DGUDING6 = this.orderTime[1] + ' 23:59:59'
        }
        this.getOrderList(param)
      },
      // 查看物流
      checkLogistics (orderNum) {
        this.$router.push({ path: '/logisticsCheck', query: { orderNum: orderNum } })
      },
      // 导出表格
      async exportExcel () {
        // exportTable('#orderList', this.$t('message.menuText.deliveryDetailTitle') + '.xlsx')
        const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        let param = {}
        // 查询客户管理
        if (this.orderNum) {
          param.ORDERNUM = this.orderNum
        }
        if (this.deliveryManId) {
          param.PSY = this.deliveryManId
        }
        if (this.deliveryManName) {
          param.PSYNAME = this.deliveryManName
        }
        if (this.senderCompany) {
          param.JJGS = this.senderCompany
        }
        if (this.orderTime && this.orderTime.length !== 0) {
          param.UGUDING6 = this.orderTime[0] + ' 00:00:00'
          param.DGUDING6 = this.orderTime[1] + ' 23:59:59'
        }
        param.PAGE = this.page_no
        param.TYPE = this.page_size
        param.FileName = this.$t('message.menuText.deliveryDetailTitle')
        let res = await exportExcel(param)
        loading.close()
        if (res.status !== 200) {
          this.$message.error('network error：' + res.status)
          return
        }
        // console.log(res.data)
        let str = HTTPS + "/xlsx/" + res.data
        window.open(str)
      },
      // 排序
      sortChange (obj) {
        // console.log(obj)
        let prop = obj.prop
        let order = obj.order
        if (prop === 'deliveryTime') {
          let param = {}
          // 查询客户管理
          if (this.orderNum) {
            param.ORDERNUM = this.orderNum
          }
          if (this.deliveryManId) {
            param.PSY = this.deliveryManId
          }
          if (this.deliveryManName) {
            param.PSYNAME = this.deliveryManName
          }
          if (this.senderCompany) {
            param.JJGS = this.senderCompany
          }
          if (this.orderTime && this.orderTime.length !== 0) {
            param.UGUDING6 = this.orderTime[0] + ' 00:00:00'
            param.DGUDING6 = this.orderTime[1] + ' 23:59:59'
          }
          this.page_no = 1
          if (order === 'ascending') {
            param.ORDERNAME = 'GUDING6'
            param.DOA = 'DESC'
          } else if (order === 'descending') {
            param.ORDERNAME = 'GUDING6'
            param.DOA = 'ASC'
          }
          console.log(param)
          this.getOrderList(param)
        }
      }
    }
  }
</script>

<style scoped>
</style>
